import { render, staticRenderFns } from "./navigator-class-setting.vue?vue&type=template&id=cc3571a8&scoped=true&"
import script from "./navigator-class-setting.ts?vue&type=script&lang=ts&"
export * from "./navigator-class-setting.ts?vue&type=script&lang=ts&"
import style0 from "./navigator-class-setting.scss?vue&type=style&index=0&id=cc3571a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3571a8",
  null
  
)

export default component.exports